import { ChangeDetectionStrategy, Component, HostListener, inject, input, InputSignal } from '@angular/core';
import { ProcessService } from '@core/services/process/process.service';
import { Process, PROCESS_STATUS } from '@core/types/process.types';
import { IconModule } from "@ogs-gmbh/ngx-m3-components";
import { DateTimeComponent } from '@shared/components/date-time/date-time.component';
import { MatButtonModule } from "@angular/material/button";
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faDownload } from '@fortawesome/pro-light-svg-icons';
import { provideTranslationScope, TranslationPipeModule } from '@ogs-gmbh/ngx-translate';
import { NotificationMenuService } from '@core/components/notification/notification-menu/services/notification-menu.service';

@Component({
  selector: 'app-process-toast',
  standalone: true,
  templateUrl: './process-toast.component.html',
  styleUrl: './process-toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ IconModule, DateTimeComponent, MatButtonModule, TranslationPipeModule ],
  providers: [ provideTranslationScope("core/process-toast") ]
})

export class ProcessToastComponent {
  private readonly _faIconLibrary: FaIconLibrary = inject(FaIconLibrary);

  private readonly _notificationMenuService: NotificationMenuService = inject(NotificationMenuService);

  private readonly _processService: ProcessService = inject(ProcessService);

  protected readonly PROCESS_STATUS: typeof PROCESS_STATUS = PROCESS_STATUS;

  public readonly process: InputSignal<Process> = input.required();

  constructor () {
    this._faIconLibrary.addIcons(faDownload);
  }

  @HostListener("click")
  protected onNotificationClick (): void {
    this._notificationMenuService.requestMenuOpen();
  }

  protected onDownloadClick (clickEvent: MouseEvent): void {
    this._processService.downloadProcess(this.process()).subscribe();
    clickEvent.stopPropagation();
  }
}
